import { render, staticRenderFns } from "./PresentacionView.vue?vue&type=template&id=1a7a8f95&scoped=true&"
import script from "./PresentacionView.vue?vue&type=script&lang=js&"
export * from "./PresentacionView.vue?vue&type=script&lang=js&"
import style0 from "./PresentacionView.vue?vue&type=style&index=0&id=1a7a8f95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7a8f95",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VBtnToggle } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VListTileSubTitle } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VNavigationDrawer } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
import { VTreeview } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VBtnToggle,
  VCard,
  VCardActions,
  VCardText,
  VDivider,
  VFlex,
  VIcon,
  VLayout,
  VListTileContent,
  VListTileSubTitle,
  VListTileTitle,
  VNavigationDrawer,
  VProgressCircular,
  VSelect,
  VSpacer,
  VTextField,
  VToolbar,
  VToolbarTitle,
  VTooltip,
  VTreeview,
})
